import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';
import { store } from '../configureStore';

export const getPrinters = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.printers
        .getPrinters(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_ALL_PRINTERS_LIST_FAILED,
              reject: actionTypes.GET_ALL_PRINTERS_LIST_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_ALL_PRINTERS_LIST_LOADING);
  const success = res => action(actionTypes.GET_ALL_PRINTERS_LIST_SUCCESS, res);

  return request();
};

export const getPrinterById = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.printers
        .getPrinterById()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_PRINTER_BY_ID_FAILED,
              reject: actionTypes.GET_PRINTER_BY_ID_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_PRINTER_BY_ID_LOADING);
  const success = res => action(actionTypes.GET_PRINTER_BY_ID_SUCCESS, res);

  return request();
};

export const updatePrinter = data => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.printers
        .updatePrinter(data)
        .then(() => {
          //Note: update the redux
          const { printersList } = store.getState().printerReducer;
          const index = printersList.findIndex(item => item.id === data.id);
          const updateList = [...printersList];
          updateList[index] = { ...data };
          dispatch(success(updateList));
        })
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_PRINTER_FAILED,
              reject: actionTypes.UPDATE_PRINTER_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_PRINTER_LOADING);
  const success = res => action(actionTypes.UPDATE_PRINTER_SUCCESS, res);

  return request();
};

export const updatePrinterIsActive = (id, isActive) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.printers
        .updatePrinterIsActive(id, isActive)
        .then(() => {
          //Note: update the redux
          const { printersList } = store.getState().printerReducer;
          const index = printersList.findIndex(item => item.id === id);
          const updateList = [...printersList];
          updateList[index] = {
            ...updateList[index],
            isActive: isActive,
          };
          dispatch(success(updateList));
        })
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_ACTIVE_PRINTER_FAILED,
              reject: actionTypes.UPDATE_ACTIVE_PRINTER_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_ACTIVE_PRINTER_LOADING);
  const success = res => action(actionTypes.UPDATE_ACTIVE_PRINTER_SUCCESS, res);

  return request();
};
